import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CantidadActivacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CANT ACTIVACION' htmlFor='number-cantidadActivacion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='cantidadActivacion'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='number-cantidadActivacion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CantidadActivacionFormGroup)
